import styled from 'styled-components'

import type { SpacingOption } from 'components/utils/spacing'
import { verticalChildSpacing } from 'components/utils/spacing'

const VerticalSpacer = styled.div<{ gap: SpacingOption }>`
  ${({ gap }) => verticalChildSpacing[gap]}
`

export default VerticalSpacer
